"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddItemErrorCodes = exports.UserTypes = void 0;
var UserTypes;
(function (UserTypes) {
    UserTypes["DEFAULT"] = "default";
    UserTypes["ORCHARD"] = "orchard";
    UserTypes["ORCHARD_ADMIN"] = "orchardAdmin";
})(UserTypes || (exports.UserTypes = UserTypes = {}));
var AddItemErrorCodes;
(function (AddItemErrorCodes) {
    AddItemErrorCodes["USER_ALREADY_OWNER"] = "USER_ALREADY_OWNER";
    AddItemErrorCodes["PRIMARY_OWNER_PERMISSION_REQUIRED"] = "PRIMARY_OWNER_PERMISSION_REQUIRED";
    AddItemErrorCodes["ACCOUNT_SELECTION_REQUIRED"] = "ACCOUNT_SELECTION_REQUIRED";
    AddItemErrorCodes["ITEM_NOT_IN_CATALOG"] = "ITEM_NOT_IN_CATALOG";
    AddItemErrorCodes["LABEL_MISMATCH"] = "LABEL_MISMATCH";
})(AddItemErrorCodes || (exports.AddItemErrorCodes = AddItemErrorCodes = {}));
//# sourceMappingURL=types.js.map